import type { Balance, BillingAccount } from '@ctct/domain-layer';

import type { TranslationGetter } from '../../../types';
import { overdueSummaryEventBus } from '../OverdueSummaryEventBus';

export class OverdueService {
  constructor(private balance: Balance, private billingAccount: BillingAccount, private t: TranslationGetter) {
    overdueSummaryEventBus.emit(
      'overduePaymentDataUpdated',
      {
        amount: this.getOverdueBalanceAmount(),
        currency: this.billingAccount.getCurrency(),
        taxAmount: 0,
      },
      {
        source: 'asyncResponse',
      }
    );
  }

  public api() {
    return {
      hasOverdueBalance: () => this.balance.hasOverdue(),
      isBalanceOverdueFree: () => this.balance.isOverdueFree(),
      getOverdue: () => {
        return { amount: this.getOverdueBalanceAmount(), currency: this.billingAccount.getCurrency() };
      },
    };
  }

  public data() {
    return {
      getCopies: () => {
        return {
          heading: this.t('application-layer.overdue-summary.heading'),
        };
      },

      getOrderRows: () => {
        return [
          {
            id: 'balance',
            mainLabel: this.t('application-layer.overdue-summary.balance'),
            secondaryLabels: [],
            priceLabel: `-${this.getOverdueBalanceLabel()}`,
            variant: 'overdue' as const,
            tooltipI18nKey: 'application-layer.overdue-summary.tooltip',
          },
        ];
      },

      getFooterRows: () => {
        return [
          {
            id: 'total',
            variant: 'bold' as const,
            label: this.t('application-layer.overdue-summary.todays-total'),
            priceLabel: this.getOverdueBalanceLabel(),
          },
        ];
      },
    };
  }

  public handlers() {
    return {};
  }

  private getOverdueBalanceAmount() {
    return this.balance.getOverdueBalance()?.priceAmount || 0;
  }

  private getOverdueBalanceLabel() {
    const negativeBalance = this.balance.getOverdueBalance();

    if (negativeBalance) {
      return negativeBalance.format(this.billingAccount.getCurrency());
    }

    return '-';
  }
}
